<template>
  <div
    class=" fixed h-full text-white duration-200 p-2 gap-y-4 bg-gray-800 flex flex-col"
    :class="isOpen ? 'w-52' : 'w-16 items-center'"
  >
    <div
      class="font-semibold inline-flex gap-2 items-center border-b border-gray-500 pb-2"
    >
      <img src="../../assets/png/favicon.png" alt="logo-head" class="w-10" />
      <p v-show="isOpen">Sekolah Desain</p>
    </div>
    <div class="flex flex-col">
      <div
        v-for="(item, index) in getRoutes"
        :key="index"
        class="relative flex flex-row items-center cursor-pointer hover:bg-gray-600 rounded-md p-2 text-sm overflow-hidden duration-300 mb-0.5"
        @click="onSelectmenu(item.children[0].name)"
        :class="[item.path == '/' ?  ($route.path == '/dashboard' ? 'bg-gray-700' : '') : $route.path.includes(item.path) ? 'bg-gray-700' : '']"
      >
        <div
          class="grid grid-cols-12 w-full"
          :class="isOpen ? 'gap-x-2' : 'gap-x-0'"
        >
          <div 
            class="relative justify-self-center"
            :class="isOpen ? 'col-span-2' : 'col-span-12'"
          >
            <div v-if="isImage(item.children[0].meta.icon)">
              <img
                :src="require(`../../assets/svg/${item.children[0].meta.icon}`)"
                alt=""
                class="w-5"
              />
            </div>
            <i v-else :class="`${item.children[0].meta.icon}`"></i>
            <span
              v-if="
                !isOpen &&
                  ((item.children[0].name == 'Webinar Plus' &&
                    WebinarApproved.length > 0) ||
                    (item.children[0].name == 'Private Webinar' &&
                      countLinkWebinarNotExist > 0))
              "
              class="absolute top-0 -right-2 flex h-2 w-2"
            >
              <span
                class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"
              ></span>
              <span
                class="relative inline-flex rounded-full h-2 w-2 bg-red-600"
              ></span>
            </span>
          </div>
          <div 
            v-show="isOpen"
            class="overflow-hidden flex items-center justify-between"
            :class="isOpen ? 'col-span-10' : ''"
          >
            <div
              v-if="item.children[0].name != 'Voucher, Kupon & Paket Webinar'"
              :class="
                item.children[0].name == 'Voucher, Kupon & Paket Webinar'
                  ? 'hover:animate-marquee whitespace-nowrap'
                  : ''
              "
            >
              {{ item.children[0].name }}
            </div>
            <marquee-text
              v-else
              :paused="isHover"
              :duration="4"
              :repeat="2"
              @mouseenter="isHover = false"
              @mouseleave="isHover = true"
            >
              <div class="pr-10">
                {{ item.children[0].name }}
              </div>
            </marquee-text>
            <span
              v-if="
                item.children[0].name == 'Webinar Plus' &&
                  WebinarApproved.length > 0
              "
              class="bg-red-600 px-1 text-xs text-white font-extrabold rounded-sm"
              :class="isOpen ? 'inline' : 'hidden'"
            >
              {{ WebinarApproved.length }}
            </span>
            <span
              v-if="
                item.children[0].name == 'Private Webinar' &&
                  countLinkWebinarNotExist > 0
              "
              class="bg-red-600 px-1 text-xs text-white font-extrabold rounded-sm"
              :class="isOpen ? 'inline' : 'hidden'"
            >
              {{ countLinkWebinarNotExist }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMe } from "@/utils/accessToken";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Sidebar",
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isHover: true,
    }
  },
  created() {
    if (this.WebinarApproved?.length == 0) {
      this.fetchWebinarApprovedByMentor();
    }
    if (Object.keys(this.privateWebinar).length == 0) {
      this.fetchAllPrivateWebinar();
    }
  },
  computed: {
    getRoutes() {
      const routes = this.$router.options.routes.filter(
        (e) => e.path !== "/login"
      );
      // console.log(routes)
      let realRoutes = [];
      realRoutes.push(routes[0]);
      let cookie = JSON.parse(getMe());
      for (let i = 0; i < cookie?.scopes?.length; i++) {
        for (let x = 0; x < routes.length; x++) {
          let routeName = routes[x].path.substring(1);
          if (
            routeName == cookie?.scopes[i] &&
            routeName != "certificate" &&
            routeName != "coupon" &&
            routeName != "webinar-package"
          ) {
            realRoutes.push(routes[x]);
          }
        }
      }

      // console.log('route', realRoutes);
      // console.log(routes)

      return realRoutes;
    },
    ...mapGetters(["WebinarApproved", "privateWebinar"]),
    countLinkWebinarNotExist() {
      if (this.privateWebinar.length > 0) {
        var count = 0;
        this.privateWebinar.forEach((el) => {
          if (el.link == "") {
            count++;
          }
        });
        return count;
      } else {
        return 0;
      }
    },
  },
  methods: {
    ...mapActions(["fetchWebinarApprovedByMentor", "fetchAllPrivateWebinar"]),
    onSelectmenu(item) {
      this.$router.push({
        name: item,
      });
    },
    isImage(icon) {
      if (icon.includes(".")) {
        return true;
      }
      return false;
    },
  },
};
</script>
